import type { ReactNode } from 'react';
import styles from './ProfilePage.module.css';

/**
 * Раздел профиля: заголовок с пояснением и панель со строками настроек.
 * `id` — якорь для оглавления слева и ссылок вида /profile#mcp.
 */
export function ProfileSection({
  id,
  title,
  description,
  children,
}: {
  id: string;
  title: string;
  description?: ReactNode;
  children: ReactNode;
}): JSX.Element {
  return (
    <section id={id} className={styles.section} data-profile-section={id}>
      <header className={styles.sectionHead}>
        <h2 className={styles.sectionTitle}>{title}</h2>
        {description && <p className={styles.sectionDescription}>{description}</p>}
      </header>
      <div className={styles.panel}>{children}</div>
    </section>
  );
}

/**
 * Строка настройки: слева что это и зачем, справа состояние и действие.
 * Под строкой — необязательная раскрывающаяся часть (ввод токена, форма).
 */
export function SettingRow({
  title,
  hint,
  aside,
  children,
  testId,
  id,
}: {
  /** Якорь для ссылки прямо на строку (например /profile#mcp). */
  id?: string;
  title: ReactNode;
  hint?: ReactNode;
  /** Состояние и основное действие — справа от названия. */
  aside?: ReactNode;
  /** Раскрытая часть под строкой. */
  children?: ReactNode;
  testId?: string;
}): JSX.Element {
  return (
    <div className={styles.row} data-testid={testId} id={id}>
      <div className={styles.rowMain}>
        <div className={styles.rowText}>
          <div className={styles.rowTitle}>{title}</div>
          {hint && <div className={styles.rowHint}>{hint}</div>}
        </div>
        {aside && <div className={styles.rowAside}>{aside}</div>}
      </div>
      {children && <div className={styles.rowBody}>{children}</div>}
    </div>
  );
}

/** Состояние подключения: зелёная точка «подключено» или серая «не задано». */
export function StatusChip({ on, children }: { on: boolean; children: ReactNode }): JSX.Element {
  return (
    <span className={`${styles.chip} ${on ? styles.chipOn : ''}`}>
      <span className={styles.chipDot} />
      {children}
    </span>
  );
}
